export const content = {
    page: {
        barrel: {
            //synthesized values, possibly compute on the fly?
            owner: "BOB BOBBERTON",
            isConsumed: false,
            referenceNumber: "12RASAUT000000001",
            totalFuel: { value: 100.00, units: "gallons" },
            totalTbds: { value: 317.60, units: "tbds" },
            miningLocation: "XYZ quarry, Utah",
            miningDate: "1st March 2025",
            processingLocation: "RASA XYZ, Utah",
            processingDate: "3rd March 2025"
        },
        mining: {
            tbdsUsed: { value: 20.00, units: "tbds" },
            location: "mine 1",
            oreType: "sand",
            extractionDate: "1st March 2025",
            tonnage: { value: 2000.00, units: "lbs" },
            equipmentId: "mine_1234",
            personnel: "John Doe",
            fuel: { value: 10.00, units: "gallons" }
        },
        transport: {
            tbdsUsed: { value: 20.00, units: "tbds" },
            origin: "mine 1",
            destination: "RASA XYZ",
            departureTime: "1st March 2025",
            arrivalTime: "2nd March 2025",
            equipmentId: "truck_1234",
            distance: { value: 200.00, units: "miles" },
            ore: { value: 2000.00, units: "lbs" },
            fuel: { value: 85.04, units: "gallons" }
        },
        crushing: {
            tbdsUsed: { value: 20.00, units: "tbds" },
            ore: { value: 4000.00, units: "lbs", type: "ore" },
            crushedOre: { value: 3700.00, units: "lbs", type: "ore" },
            efficiency: { value: 42.5, units: "percent" },
            gradation: {value: 0.5, units: "inch"},
            equipmentId: "crusher_1234",
            fuel: { value: 170.00, units: "gallons", type: "fuel" }
        },
        psa: {
            crushedOre: { value: 3700.00, units: "lbs", type: "ore" },
            diesel: { value: 200.00, grade: 1, units: "lbs" },
            bitumen: { value: 500.00, units: "lbs", grade: 1 },
            sand: { value: 3000.00, fitness: 10, units: "lbs" },
            fuel: { value: 170.00, units: "gallons", type: "fuel" },
            aggregateWeight: { value: 4400.00, units: "lbs" },
            aggregateWaterContent: { value: 5.00, units: "percent" },
            tbdsUsed: { value: 20.00, units: "tbds" },
        },
        fractionate: {
            tbdsUsed: "20",
            title: "20 ",
            outputs: [{
                percent: "100",
                sand: { value: 3700.00, units: "lbs", fitness: 10 },
                asphaltenes: { value: 700.00, units: "lbs", grade: 1 },
                maltenes: { value: 700.00, units: "lbs", grade: 1 },
                resins: { value: 700.00, units: "lbs", grade: 1 },
                aromatics: { value: 700.00, units: "lbs", grade: 1 },
                saturates: { value: 200.00, units: "lbs" },
                waxContent: { value: 500.00, units: "lbs" },
                fuel: { value: 170.00, units: "gallons", type: "fuel" },
                description: "asphalt paving"
            }]
        }
    }
}


//LANDING PAGE - leave your verbiage on top as is
//MINING
//Location, ore type, extraction date, tonnage, equipment ID,
//personnel.
//Energy used

//CRUSHING
//Weight in, weight out, efficiency percentage, gradation, date,
//equipment ID.
//Energy used

//TRANSPORT
//Origin, destination, departure time, arrival time, weight,
//equipment ID.
//Energy used

//PSA
//Input weight, outputs: sand weight, sand fineness, bitumen weight,
//bitumen grade, aggregate weight, aggregate water content
//Energy used

//FRACTIONING
//Inputs, output weights and grades, asphaltenes, maltenes, resins,
//aromatics, saturates, diesel, wax content.
//Energy used
